const generateSDDMessageForBadging = (eventData, categoryID, sddLabel = '', userDate = new Date()) => {
  const isSDD = sddLabel.toLowerCase().includes('same-day delivery');

  let sddEventData;
  if (isSDD) {
    sddEventData = { ...eventData, eventAttributes: eventData.eventAttributes.filter(({ orderType }) => orderType === 'SDD') };
  } else {
    sddEventData = { ...eventData, eventAttributes: eventData.eventAttributes.filter(({ orderType }) => orderType === 'NDD') };
  }

  const campaignStartDate = new Date(sddEventData.startTime);
  const campaignCutoffDate = new Date(sddEventData.endTime);

  if (sddEventData.eventAttributes.length) {
    if (sddEventData.categoryIds && sddEventData.categoryIds.length) {
      if (!sddEventData.categoryIds.includes(categoryID)) return false;
    }

    const sddStartDate = new Date(sddEventData.eventAttributes[0].startTime);
    const sddCutOffDate = new Date(sddEventData.eventAttributes[0].cutOffTime);

    if (userDate >= campaignStartDate && userDate <= campaignCutoffDate) {
      if (userDate >= sddStartDate && userDate <= sddCutOffDate) {
        return { message: sddEventData.eventAttributes[0].message, color: sddEventData.badgingColor };
      }
      return { color: sddEventData.badgingColor };
    }
  }
  return false;
};
export default generateSDDMessageForBadging;
